import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'
import {
  ActivityDto,
  ResourceDto,
  ResourceSummaryDto,
} from '../../services/APIs/InternalAPI/internal-api.contracts'

export type CapabilitiesSettingsState = {
  Machines: ResourceDto[]
  Templates: ResourceSummaryDto[]
}

const initialState: CapabilitiesSettingsState = {
  Machines: undefined,
  Templates: undefined,
}

function updateMachineActivity(
  state: CapabilitiesSettingsState,
  machineIdToUpdate: string,
  activityToUpdate: Partial<ActivityDto>
): ResourceDto[] {
  return [
    ...state.Machines.map((machine) => {
      if (machine.id === machineIdToUpdate) {
        const newResource = Object.assign({}, machine)

        newResource.activities = newResource.activities.map((activity) => {
          if (
            _.isEqual(
              activity.workingStepType,
              activityToUpdate.workingStepType
            )
          ) {
            return {
              ...activity,
              ...activityToUpdate,
            }
          }

          return activity
        })
        return newResource
      } else {
        return machine
      }
    }),
  ]
}

const capabilitiesSlice = createSlice({
  initialState: initialState,
  name: 'capabilities',
  reducers: {
    machinesLoaded: (
      state,
      action: PayloadAction<{ machines: ResourceDto[] }>
    ) => {
      state.Machines = action.payload.machines
    },
    uploadProgress: () => {
      // todo: UPDATE UPLOAD PROGRESS STATE?
    },
    unloadMachines: (state) => {
      state = initialState
    },
    machineTemplatesLoaded: (
      state,
      action: PayloadAction<{ templates: ResourceSummaryDto[] }>
    ) => {
      state.Templates = action.payload.templates
    },
    techniqueUpdated: (
      state,
      action: PayloadAction<{ machineId: string; technique: ActivityDto }>
    ) => {
      state.Machines = updateMachineActivity(
        state,
        action.payload.machineId,
        action.payload.technique
      )
    },
    unloadMachineTemplates: (state) => {
      state.Templates = undefined
    },
  },
})

export default capabilitiesSlice.reducer
export const capabilitiesSettingsActions = capabilitiesSlice.actions
